import debug from 'debug';
import { sendToServer } from './sendToServer';
import { EVENT_NAMES } from './const';

const log = debug('beacon:plutoTarget');

let lastHitID = 0;

const coreToApi = (event) => {
  let res = { ...event };
  switch (event.eventName) {
    case EVENT_NAMES.HEART_BEAT:
      if (event.value % 20 !== 0) {
        res = undefined;
      }
      break;
    default:
      break;
  }
  return res;
};

const plutoTarget = (events) =>
  events.forEach((evts) => {
    const evtsArr = Array.isArray(evts) ? evts : [evts];
    evtsArr.forEach((evt) => {
      if (evt && (!evt.eventCategory || !evt.eventName)) {
        log('Dropping event: Needs `eventCategory` and `eventName`.', evt);
        return;
      }

      const msg = coreToApi({
        hitID: lastHitID + 1, // hitID can be overwritten by any event.
        eventEmittedTimestamp: new Date().toISOString(),
        ...evt,
      });
      if (msg) {
        log('Category: %o Event: %o', msg.eventCategory, msg.eventName, msg);
        lastHitID = msg.hitID;
        sendToServer(msg);
      }
    });
  });

export { plutoTarget };
